<template>
  <div class="clothes">
    <v-system-bar height="35">
      <v-icon class="mr-2" color="red">fa-bullhorn</v-icon>
      <div class="announcement-container">
        <div id="announcement" style="left: 100%">
          <template v-for="announcement in announcements">
            <span style="width: 500px"></span>
            <span>{{ announcement }}</span>
          </template>
        </div>
      </div>
    </v-system-bar>

    <Gallery
      v-if="product.data.length" 
      v-for="product in products"
      :title="product.type.name" 
      :to="`/job/${product.type.num}`" 
      :items="product.data" 
    ></Gallery>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Gallery from '@/components/Gallery'
export default {
  components: { Gallery },
  data() {
    return {
      announcements: [],
      carouselItemNum: 5,
      moving: false,
      timer: '',
      windowWidth: window.innerWidth,
      basicTransform: '',
      carouselItems: [],
      focusCarouselItem: 0,
      products: []
    }
  },
  created() {
    this.seller_job_types.forEach(type => {
      this.getProductsByJobType(type)
    })
  },
  mounted() {
    this.getAnnouncements().then(() => {
      this.announcementAnimation()
    })
  },
  watch: {
    seller_job_types() {
      this.seller_job_types.forEach(type => {
        this.getProductsByJobType(type)
      })
    }
  },
  computed: {
    ...mapState('global', ['seller_job_types']),
  },
  methods: {
    announcementAnimation() {
      let announcement = document.getElementById('announcement')
      setInterval(() => {
        if(!announcement) {
          return
        }
        let leftVal = parseInt(announcement.style.left, 10)
        if(leftVal < 0 && Math.abs(leftVal) > announcement.clientWidth) {
          announcement.style.left = window.innerWidth + 'px'
          return
        }
        announcement.style.left = (leftVal - 1) + 'px'
      }, 10)
    },
    getProductsByJobType(type) {
      this.axios.post('/products/condition', {
        search: [
          {table: 'sellers', column: 'job', keyword: [type.num, type.num]},
          {table: 'products', column: 'product_type', keyword: 'clothes'}
        ],
        page: 1,
        size: 50,
        includeSeller: true
      }).then(response => {
        let products = response.data.data.map(product => {
          product.latest_product = product
          return product
        })
        this.products.push({ type: { name: type.name, num: type.num }, data: products })
      })
    },
    getAnnouncements() {
      return this.axios.get('/announcement').then(response => {
        this.announcements = response.data.data
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.clothes {
  .v-responsive__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .announcement-container {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    div {
      position: absolute;
      width: max-content;
      display: flex;
      align-items: center;
      height: 35px;
      span {
        height: 20px;
        float: left;
        white-space: nowrap;
      }
    }
  }
}
</style>